import { Action } from "redux";
import {
  FetchMenuListSuccessPayload,
  PublicationBody,
  PublictionMenuPayload,
  UploadJsonPayload,
} from "./types";
import { MenuListActionTypes } from "./types/actionTypes";

// ACTION INTERFACE
export interface fetchMenuListAction extends Action<MenuListActionTypes> {
  type: MenuListActionTypes.FETCH_MENU_LIST_SAGA;
  payload: string;
}
export interface fetchPublicationMenuCountAction
  extends Action<MenuListActionTypes> {
  type: MenuListActionTypes.FETCH_PUBLICATION_COUNT_SAGA;
}

export interface fetchPublicationMenuCountSuccessAction
  extends Action<MenuListActionTypes> {
  type: MenuListActionTypes.FETCH_PUBLICATION_COUNT_SUCCESS;
  payload: PublicationBody[] | null;
}

export interface clearMenuListAction extends Action<MenuListActionTypes> {
  type: MenuListActionTypes.CLEAR_MENU_LIST;
}

export interface updateMenuLoadingAction extends Action<MenuListActionTypes> {
  type: MenuListActionTypes.UPDATE_MENU_LOADING;
  payload: boolean
}

export interface fetchMenuListSuccessAction
  extends Action<MenuListActionTypes> {
  type: MenuListActionTypes.FETCH_MENU_LIST_SUCCESS;
  payload: FetchMenuListSuccessPayload;
}

export interface publicationMenuAction extends Action<MenuListActionTypes> {
  type: MenuListActionTypes.PUBLICATION_MENU_SAGA;
  payload: PublictionMenuPayload[];
}

export interface openUploadModalAction extends Action<MenuListActionTypes> {
  type: MenuListActionTypes.OPEN_UPLOAD_MODAL;
}

export interface closeUploadModalAction extends Action<MenuListActionTypes> {
  type: MenuListActionTypes.CLOSE_UPLOAD_MODAL;
}

export interface deleteMenuAction extends Action<MenuListActionTypes> {
  type: MenuListActionTypes.DELETE_MENU_SAGA;
  payload: { menuId: string };
}

export interface updateMenuAction extends Action<MenuListActionTypes> {
  type: MenuListActionTypes.UPDATE_MENU_SAGA;
}

export interface closePublicationCountAlertAction
  extends Action<MenuListActionTypes> {
  type: MenuListActionTypes.CLOSE_PUBLICATION_COUNT_ALERT;
  payload: { aggregatorName: string; count: number };
}

export interface updateMoyskladMenuAction extends Action<MenuListActionTypes> {
  type: MenuListActionTypes.UPDATE_MOYSKLAD_MENU_SAGA;
}

export interface requestYandexPublicationAction
  extends Action<MenuListActionTypes> {
  type: MenuListActionTypes.REQUEST_YANDEX_PUBLICATION_SAGA;
  payload: {
    restaurantId: string;
    groupId: string;
  };
}

export interface recoveryMenuAction extends Action<MenuListActionTypes> {
  type: MenuListActionTypes.RECOVERY_MENU_SAGA;
  payload: { menuId: string; restaurantId: string };
}
export interface fetchJsonFileAction extends Action<MenuListActionTypes> {
  type: MenuListActionTypes.FETCH_JSON_FILE_SAGA;
  payload: string;
}

export interface uploadJsonFileAction extends Action<MenuListActionTypes> {
  type: MenuListActionTypes.UPLOAD_JSON_FILE_SAGA;
  payload: UploadJsonPayload;
}

export interface createPosMenuAction extends Action<MenuListActionTypes> {
  type: MenuListActionTypes.CREATE_POS_MENU_SAGA;
  payload: { aggregator: string };
}

// ACTOION CREATORS
export const setIsFetching = (value: boolean) => ({
  type: MenuListActionTypes.UPDATE_MENU_LOADING,
  payload: value,
});

export const fetchMenuList = (query: string): fetchMenuListAction => ({
  type: MenuListActionTypes.FETCH_MENU_LIST_SAGA,
  payload: query,
});

export const fetchMenuListSuccess = (
  payload: FetchMenuListSuccessPayload
): fetchMenuListSuccessAction => ({
  type: MenuListActionTypes.FETCH_MENU_LIST_SUCCESS,
  payload,
});

export const clearMenuList = (): clearMenuListAction => ({
  type: MenuListActionTypes.CLEAR_MENU_LIST,
});

export const publicationMenu = (
  payload: PublictionMenuPayload[]
): publicationMenuAction => ({
  type: MenuListActionTypes.PUBLICATION_MENU_SAGA,
  payload,
});

export const openUploadModal = (): openUploadModalAction => ({
  type: MenuListActionTypes.OPEN_UPLOAD_MODAL,
});

export const closeUploadModal = (): closeUploadModalAction => ({
  type: MenuListActionTypes.CLOSE_UPLOAD_MODAL,
});

export const deleteMenu = (payload: { menuId: string }): deleteMenuAction => ({
  type: MenuListActionTypes.DELETE_MENU_SAGA,
  payload,
});

export const updateMenu = (): updateMenuAction => ({
  type: MenuListActionTypes.UPDATE_MENU_SAGA,
});

export const autoUpdateMenu = (payload: any) => ({
  type: MenuListActionTypes.AUTO_UPDATE_MENU_SAGA,
  payload,
});

export const updateMoyskladMenu = (): updateMoyskladMenuAction => ({
  type: MenuListActionTypes.UPDATE_MOYSKLAD_MENU_SAGA,
});

export const requestYandexPublication = (payload: {
  restaurantId: string;
  groupId: string;
}): requestYandexPublicationAction => ({
  type: MenuListActionTypes.REQUEST_YANDEX_PUBLICATION_SAGA,
  payload,
});

export const fetchMenuPublicationCount =
  (): fetchPublicationMenuCountAction => ({
    type: MenuListActionTypes.FETCH_PUBLICATION_COUNT_SAGA,
  });

export const fetchMenuPublicationCountSuccess = (
  payload: PublicationBody[] | null
): fetchPublicationMenuCountSuccessAction => ({
  type: MenuListActionTypes.FETCH_PUBLICATION_COUNT_SUCCESS,
  payload,
});

export const closePublicationCountAlert = (payload: {
  aggregatorName: string;
  count: number;
}): closePublicationCountAlertAction => ({
  type: MenuListActionTypes.CLOSE_PUBLICATION_COUNT_ALERT,
  payload,
});

export const recoveryMenu = (
  menuId: string,
  restaurantId: string
): recoveryMenuAction => {
  return {
    type: MenuListActionTypes.RECOVERY_MENU_SAGA,
    payload: { menuId, restaurantId },
  };
};

export const fetchJsonFile = (menuId: string): fetchJsonFileAction => ({
  type: MenuListActionTypes.FETCH_JSON_FILE_SAGA,
  payload: menuId,
});

export const uploadJsonFile = (
  menuId: string,
  file: File,
  delivery_service: string
): uploadJsonFileAction => ({
  type: MenuListActionTypes.UPLOAD_JSON_FILE_SAGA,
  payload: { menuId, file, delivery_service },
});

export const createPosMenu = (aggregator: string): createPosMenuAction => ({
  type: MenuListActionTypes.CREATE_POS_MENU_SAGA,
  payload: { aggregator },
});

// ALL MENU LIST ACTIONS
export type MenuListActions =
|updateMenuLoadingAction
  | fetchMenuListAction
  | clearMenuListAction
  | publicationMenuAction
  | openUploadModalAction
  | closeUploadModalAction
  | deleteMenuAction
  | updateMenuAction
  | fetchMenuListSuccessAction
  | fetchPublicationMenuCountSuccessAction
  | closePublicationCountAlertAction
  | recoveryMenuAction
  | fetchJsonFileAction
  | uploadJsonFileAction
  | requestYandexPublicationAction;
